if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
    }

    get selectedOptionValues() {
      const options = this.querySelectorAll('.m-product-option select, .m-product-option input');
      const selectedValues = new Map();

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          const checkedInput = field.checked ? field : null;
          if (checkedInput) {
            selectedValues.set(fieldName, checkedInput.dataset.optionValueId);
          }
        }
      });

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (!selectedValues.has(fieldName)) {
          if (field.tagName.toLowerCase() === "select") {
            const firstValidOption = Array.from(field.options).find(
              (opt) => !opt.disabled
            );
            if (firstValidOption) {
              selectedValues.set(
                fieldName,
                firstValidOption.dataset.optionValueId
              );
            }
          } else if (
            field.tagName.toLowerCase() === "input" &&
            field.type === "radio"
          ) {
            const firstInput = field;
            if (firstInput) {
              selectedValues.set(fieldName, firstInput.dataset.optionValueId);
            }
          }
        }
      });

      const result = [];
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (selectedValues.has(fieldName)) {
          const optionValueId = selectedValues.get(fieldName);
          if (optionValueId && !result.includes(optionValueId)) {
            result.push(optionValueId);
          }
        }
      });
      return result;
    }

    connectedCallback() {
      this.addEventListener('change', (event) => {
        const target = this.getInputForEventTarget(event.target);
        MinimogEvents.emit(MinimogTheme.pubSubEvents.optionValueSelectionChange, { data: { selectedOptionValues: this.selectedOptionValues, event, target } });
      });
    }

    getInputForEventTarget(target) {
      return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    }
  }
  customElements.define("variant-picker", VariantPicker);
}

(() => {
  const states = new Map();
  const find = () => Array.from(document.querySelectorAll('.m-main-product variant-picker')).find(p => groups(p).size);
  const groups = p => {
    const all = Array.from(p.querySelectorAll('.m-product-option__inner'));
    return {
      size: all.find(e => /^(beden|size)$/i.test(e.dataset.optionName.trim())),
      pack: all.find(e => /koli|paket|adet|miktar/i.test(e.dataset.optionName))
    };
  };
  const state = p => {
    const key = p.dataset.productId + ':' + p.dataset.sectionId;
    if (!states.has(key)) states.set(key, { pack: null, size: null });
    return states.get(key);
  };
  const prompt = p => {
    const g = groups(p), s = state(p);
    return g.pack && !s.pack ? p.dataset.kasPackagePrompt : !s.size ? p.dataset.kasSizePrompt : p.dataset.kasSelectionReady;
  };
  const apply = () => {
    const p = find();
    if (!p) return;
    const g = groups(p), s = state(p);
    if (!g.pack) s.pack = true;
    for (const [key, group] of Object.entries(g)) {
      if (!group) continue;
      group.dataset.kasChoicePending = s[key] ? 'false' : 'true';
      if (!s[key]) {
        group.querySelectorAll('input[type="radio"]').forEach(e => { e.checked = false; });
        const label = group.querySelector('.option-label--selected');
        if (label && label.textContent !== '') label.textContent = '';
      }
    }
    let note = p.querySelector('.kas-selection-notice');
    if (!note) {
      note = document.createElement('p');
      note.className = 'kas-selection-notice';
      note.setAttribute('role', 'status');
      note.setAttribute('aria-live', 'polite');
      p.append(note);
    }
    const text = prompt(p);
    if (note.textContent !== text) note.textContent = text;
    const ready = !!(s.pack && s.size);
    p.dataset.kasSelectionReadyState = ready ? 'true' : 'false';
    document.querySelectorAll('form[data-product-id="' + p.dataset.productId + '"] button[name="add"]').forEach(b => {
      const value = ready ? 'false' : 'true';
      if (b.getAttribute('aria-disabled') !== value) b.setAttribute('aria-disabled', value);
    });
  };
  const warn = p => {
    apply();
    const g = groups(p), s = state(p);
    const group = g.pack && !s.pack ? g.pack : g.size;
    if (group) {
      group.setAttribute('tabindex', '-1');
      group.focus({ preventScroll: true });
      group.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
  };
  document.addEventListener('click', event => {
    const p = find();
    if (!p || !(event.target instanceof Element)) return;
    const g = groups(p), s = state(p);
    const group = event.target.closest('.m-product-option__inner');
    if (group === g.size && g.pack && !s.pack) {
      event.preventDefault();
      event.stopImmediatePropagation();
      warn(p);
      return;
    }
    const button = event.target.closest('button[name="add"], .shopify-payment-button');
    const form = button?.closest('form');
    if (button && form?.dataset.productId === p.dataset.productId && !(s.pack && s.size)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      warn(p);
    }
  }, true);
  document.addEventListener('change', event => {
    const p = find();
    if (!p || !(event.target instanceof Element) || !p.contains(event.target)) return;
    const g = groups(p), s = state(p);
    const group = event.target.closest('.m-product-option__inner');
    if (group === g.pack) {
      s.pack = event.target.value;
      s.size = null;
      g.size.querySelectorAll('input[type="radio"]').forEach(e => { e.checked = false; });
    } else if (group === g.size) {
      if (g.pack && !s.pack) {
        event.preventDefault();
        event.stopImmediatePropagation();
        warn(p);
        return;
      }
      s.size = event.target.value;
    }
    queueMicrotask(apply);
  }, true);
  document.addEventListener('submit', event => {
    const p = find();
    if (!p || event.target.dataset.productId !== p.dataset.productId) return;
    const s = state(p);
    if (!(s.pack && s.size)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      warn(p);
    }
  }, true);
  const start = () => {
    apply();
    const root = document.querySelector('.m-main-product');
    if (root) new MutationObserver(() => queueMicrotask(apply)).observe(root, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
